// 主题类型定义
export type ThemeType = 'green' | 'red' | 'red_v2' | 'purple' | 'yellow' | 'blue' | 'white'| 'deeppurple' | 'brown'| 'black'| 'star'| string; // 使用string方便后续扩展更多主题

// 主题配置接口 
export interface ThemeConfig {
    name: string; // 主题名称
    cssPath: string; // CSS文件路径
    themeColor: string; // 主题色（用于meta标签）
    backgroundColor: string; // 背景色（用于PWA）
}

// 主题配置映射表
export const themeConfigs: Record<string, ThemeConfig> = {
    green: {
        name: '绿色主题',
        cssPath: './green.css',
        themeColor: '#007135',
        backgroundColor: '#007135',
    },
    red: {
        name: '红色主题',
        cssPath: './red.css',
        themeColor: '#930903',
        backgroundColor: '#930903',
    },
    red_v2: {
        name: '红色主题V2',
        cssPath: './red.css',
        themeColor: '#930903',
        backgroundColor: '#930903',
    },
    purple: {
        name: '紫色主题',
        cssPath: './purple.css',
        themeColor: '#1b0249',
        backgroundColor: '#1b0249',
    },
    yellow: {
        name: '黄色主题',
        cssPath: './yellow.css',
        themeColor: '#edc153',
        backgroundColor: '#edc153',
    },
    blue: {
        name: '蓝色主题',
        cssPath: './blue.css',
        themeColor: '#0055aa',
        backgroundColor: '#0055aa'
    },
    white: {
        name: '白色主题',
        cssPath: './white.css',
        themeColor: '#ffffff',
        backgroundColor: '#ffffff'
    },
    deeppurple: {
        name: '深紫色主题',
        cssPath: './deeppurple.css',
        themeColor: '#8b2e8a',
        backgroundColor: '#ffffff'
    },
    brown: {
        name: '棕色主题',
        cssPath: './brown.css',
        themeColor: '#8a5d2e',
        backgroundColor: '#2d1b0a'
    },
    black: {
        name: '黑色主题',
        cssPath: './black.css',
        themeColor: '#141414',
        backgroundColor: '#141414'
    },
        star: {
        name: '星空主题',
        cssPath: './star.css',
        themeColor: '#1a1a2e',
        backgroundColor: '#1a1a2e'
    },
    // 后续可以在这里添加更多主题
    // 'blue': {
    //     name: '蓝色主题',
    //     cssPath: './blue.css',
    //     themeColor: '#0055aa',
    //     backgroundColor: '#0055aa'
    // },
};

// 获取主题配置
export function getThemeConfig(theme: ThemeType): ThemeConfig {
    // 检查是否存在此主题配置
    if (themeConfigs[theme]) {
        return themeConfigs[theme];
    }
    // 如果不存在，返回默认主题（绿色）
    console.warn(`未找到主题"${theme}"的配置，使用默认主题`);
    return themeConfigs['green'];
}

// 默认主题
export const DEFAULT_THEME: ThemeType = 'green';
